import { dasModal } from "../modal_v2.js";
import { matchService } from "./matchService_v2.js";
import { board } from "../game/gameBoard_v2.js";
import { currentMatch } from "./currentMatch_v2.js";
import { identityService } from "../profile/identityService_v2.js";
import { iPop } from "../ipop_v2.js";
import { eventHub } from "../eventHub_v2.js";
import { escapeHtml } from "../escapeHtml_v2.js";

const handleNotifyResign = () => {
  dasModal.render(
    `<br>Are you sure you want to resign?<div id="resignSplainer" class="i">ⓘ</div><br>
    <br>
    <button class="ruSure" id="yesResign">Yes</button><button class="ruSure" id="noResign">No</button>
    `,
  );
};

const handleYesResign = async () => {
  const match = matchService.getCurrentMatch().currentMatch;
  const isTurn = match.turn === match.p1UserID ? match.p1Name : match.p2Name;
  const isTurnName = identityService.parseName(isTurn);
  const nachoTurn = match.turn === match.p1UserID ? match.p2Name : match.p1Name;
  let nachoName = identityService.parseName(nachoTurn);

  dasModal.close();
  await matchService.notifyResign();
  dasModal.render(`<div class=max>You have resigned.</div>`);
  if (currentMatch.getSize() === "normal") {
    currentMatch.render("normal");
  }
  board.render();
};

const renderResignSplainer = (event) => {
  const match = matchService.getCurrentMatch().currentMatch;
  const nachoTurn = match.turn === match.p1UserID ? match.p2Name : match.p1Name;
  let nachoName = identityService.parseName(nachoTurn);
  iPop.render({
    text: `It means ${escapeHtml(nachoName)} will win this match. It will affect your ranking.`,
    event,
  });
};

const handleGotResignNotification = async () => {
  dasModal.close();
  const match = matchService.getCurrentMatch().currentMatch;
  const nachoTurn = match.turn === match.p1UserID ? match.p2Name : match.p1Name;
  let nachoName = identityService.parseName(nachoTurn);
  const isTurn = match.turn === match.p1UserID ? match.p1Name : match.p2Name;
  const isTurnName = identityService.parseName(isTurn);

  dasModal.render(
    `<br><p>${escapeHtml(isTurnName)} has resigned.</p> 
    <p>${escapeHtml(nachoName)} has won this match.</p>
    <br>
    `,
  );
  await matchService.completeResign();
};

eventHub.registerEvent("click", "resignSplainer", renderResignSplainer);
eventHub.registerEvent("click", "noResign", dasModal.close);
eventHub.registerEvent("click", "yesResign", handleYesResign);

export const resign = {
  handleGotResignNotification,
  handleNotifyResign,
};
